export const translations: Record<string, string> = {
  ACTIVE: 'Activo',
  INACTIVE: 'Inactivo',
  LEAVE: 'De licencia',
  VACATION: 'De vacaciones',
  SUSPENDED: 'Suspendido',
  DRAFT: 'Borrador',
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
  CANCELLED: 'Cancelada',
  ACCEPTED: 'Aceptado',
  OBSERVED: 'Observado',
  ARCHIVED: 'Archivado',
  SIGNED: 'Firmado',
  SUCCESS: 'Correcto',
  FAILED: 'Fallido',
  PROCESSING: 'Procesando',
  SENT: 'Enviado',
  CONFORMITY: 'En conformidad',
  NON_CONFORMITY: 'En disconformidad',
  DAYS: 'Días',
  HOURS: 'Horas',
  ADMIN: 'Administrador',
  SUPERADMIN: 'Administrador general',
  HR_OPERATOR: 'Recursos Humanos',
  EMPLOYEE: 'Empleado',
  SUPERVISOR: 'Supervisor',
  SYSTEM: 'Sistema',
  EMPLOYEE_CREATED: 'Alta de empleado',
  EMPLOYEE_UPDATED: 'Modificación del legajo',
  EMPLOYEE_DEACTIVATED: 'Baja de empleado',
  EMPLOYEE_PHOTO_UPDATED: 'Fotografía actualizada',
  EMPLOYEE_CATALOG_CREATED: 'Configuración laboral creada',
  EMPLOYEE_DOCUMENT_CATEGORY_CREATED: 'Categoría documental creada',
  EMPLOYEE_DOCUMENT_UPLOADED: 'Documento cargado',
  EMPLOYEE_DOCUMENT_UPDATED: 'Documento modificado',
  EMPLOYEE_DOCUMENT_DELETED: 'Documento dado de baja',
  EMPLOYEE_DOCUMENT_DOWNLOADED: 'Documento descargado',
  EMPLOYEE_DOCUMENT_VIEWED: 'Documento consultado',
  RECEIPT_SIGNED: 'Recibo firmado',
  RECEIPT_SIGNED_CONFORMITY: 'Firma en conformidad',
  RECEIPT_SIGNED_NON_CONFORMITY: 'Firma en disconformidad',
  RECEIPT_AVAILABLE: 'Recibo publicado',
  LEAVE_CREATED: 'Licencia registrada',
  LEAVE_REQUESTED: 'Licencia solicitada',
  LEAVE_APPROVED: 'Licencia aprobada',
  LEAVE_REJECTED: 'Licencia rechazada',
  LEAVE_CANCELLED: 'Licencia cancelada',
  LEAVE_ATTACHMENT_ADDED: 'Adjunto de licencia agregado',
  MEDICAL_CERTIFICATE_UPLOADED: 'Certificado médico cargado',
  MEDICAL_CERTIFICATE_REVIEWED: 'Certificado médico revisado',
  MEDICAL_CERTIFICATE_DOWNLOADED: 'Certificado médico descargado',
  MEDICAL_CERTIFICATE_DELETED: 'Certificado médico dado de baja',
  MEDICAL_CERTIFICATES_ACCESSED: 'Bandeja de certificados consultada',
  NOTIFICATION_DELIVERY_ATTEMPT: 'Intento de envío de notificación',
};
export const translate = (value?: string | null) =>
  !value
    ? '—'
    : translations[value] ||
      value
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/^./, (letter) => letter.toUpperCase());
